
export default class ContactSupportRequestModel {
    public givenName: string = '';
    public surname: string = '';
    public emailAddress: string = '';
    public message: string = '';
}
